import { render, staticRenderFns } from "./person_change_pc.vue?vue&type=template&id=f4d9f452&scoped=true&"
import script from "./person_change_pc.vue?vue&type=script&lang=js&"
export * from "./person_change_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9f452",
  null
  
)

export default component.exports